import { render, staticRenderFns } from "./OrganizationChartList.vue?vue&type=template&id=49522690&"
import script from "./OrganizationChartList.vue?vue&type=script&lang=js&"
export * from "./OrganizationChartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports